import _classCallCheck from "/builds/thema-developers/nuovo-osix-configurator-usa/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/thema-developers/nuovo-osix-configurator-usa/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/thema-developers/nuovo-osix-configurator-usa/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/thema-developers/nuovo-osix-configurator-usa/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.find.js";
import { __decorate } from "tslib";
import Component from "vue-class-component";
import Vue from "vue";

var Confronta = /*#__PURE__*/function (_Vue) {
  _inherits(Confronta, _Vue);

  var _super = _createSuper(Confronta);

  function Confronta() {
    _classCallCheck(this, Confronta);

    return _super.apply(this, arguments);
  }

  _createClass(Confronta, [{
    key: "configurations",
    get: function get() {
      return this.$store.state.configurator.configurations;
    }
  }, {
    key: "isConfigurationSaved",
    get: function get() {
      return this.$store.getters["configurator/isConfigurationSaved"];
    }
  }, {
    key: "items",
    get: function get() {
      return this.$store.state.configurator.frontali.items;
    }
  }, {
    key: "colori",
    get: function get() {
      return this.$store.state.configurator.frontali.colors;
    }
  }, {
    key: "temples",
    get: function get() {
      return this.$store.state.configurator.aste.allColors;
    }
  }, {
    key: "lentiSole",
    get: function get() {
      return this.$store.getters["configurator/lenti/sunLenses"];
    }
  }, {
    key: "restoreConfiguration",
    value: function restoreConfiguration(id) {
      this.$store.commit("configurator/restoreConfiguration", id);
    }
  }, {
    key: "removeConfiguration",
    value: function removeConfiguration(id) {
      this.$store.commit("configurator/removeConfiguration", id);
    }
  }, {
    key: "clearAllConfigurations",
    value: function clearAllConfigurations() {
      this.$store.commit("configurator/clearAllConfigurations");
    }
    /**
     * Construct an ordered array containing all the images of the frontals
     */

  }, {
    key: "frontImages",
    get: function get() {
      var _this = this;

      var images = [];
      this.configurations.forEach(function (c) {
        var item = _this.items.find(function (t) {
          if (c.frontale && t.U_THE_MODELLO == c.frontale.U_THE_MODELLO) {
            return true;
          }
        });

        if (item) images.push(item.imageUrl);
      });
      return images;
    }
    /**
     * Construct an ordered array containing all the images of the front colors
     */

  }, {
    key: "frontColorImages",
    get: function get() {
      var _this2 = this;

      var images = [];
      this.configurations.forEach(function (c) {
        var item = _this2.colori.find(function (t) {
          if (c.colore && t.U_THE_COLORE == c.colore.U_THE_COLORE) {
            return true;
          }
        });

        if (item) images.push(item.imageUrl);
      });
      return images;
    }
    /**
     * Construct an ordered array containing all the images of the temple colors
     */

  }, {
    key: "templesColorImages",
    get: function get() {
      var _this3 = this;

      var images = [];
      this.configurations.forEach(function (c) {
        var item = _this3.temples.find(function (t) {
          if (c.coloreAste && t.U_THE_COLORE == c.coloreAste.U_THE_COLORE) {
            return true;
          }
        });

        if (item) images.push(item.imageUrl);
      });
      return images;
    }
    /**
     * Construct an ordered array containing all the images of the lenses
     */

  }, {
    key: "lensImages",
    get: function get() {
      var _this4 = this;

      var images = [];
      this.configurations.forEach(function (c) {
        var item = _this4.lentiSole.find(function (t) {
          if (c.lensSole && t.ItemCode == c.lensSole.ItemCode) {
            return true;
          }
        });

        if (item && item.imageUrl) images.push(item.imageUrl);
      });
      return images;
    }
  }]);

  return Confronta;
}(Vue);

Confronta = __decorate([Component({})], Confronta);
export default Confronta;